/** 幣別 */
export enum Currency {
  /** 美金 */
  USD = 'USD',
  /** 台幣 */
  TWD = 'TWD'
}
